<script setup lang="ts">
import { relsInjectKey } from "~~/helpers/injectKeys";
import type { BlokNewsList } from "@/.storyblok/types/120421/storyblok-components";

const props = defineProps<{
  blok: BlokNewsList;
}>();

const rels = inject(relsInjectKey, []);
</script>

<template>
  <BaseContentSection
    v-for="(article, index) of blok.news"
    :key="article._uid"
    :background-color="index % 2 == 0 ? 'light' : 'medium'"
  >
    <StoryblokComponent
      :blok="article"
      :is-switched="index % 2 == 0 ? false : true"
    ></StoryblokComponent>
  </BaseContentSection>
</template>

<style lang="scss" scoped></style>
